/*
 * @Author: lixin jiang
 * @Date: 2021-07-08 09:18:12
 * @LastEditTime: 2021-07-08 09:40:01
 * @LastEditors: lixin jiang
 * @Description:
 * @FilePath: /kitchen-online-web/src/components/ArcButton/context.js
 * @
 */

import * as React from 'react';

const ArcButtonGroupContext = React.createContext({ onChange: () => {} });

export const ArcButtonGroupContextProvider = ArcButtonGroupContext.Provider;

export default ArcButtonGroupContext;
